/**
 * Application Configuration Constants
 * Central location for all timing, cache, and configuration values
 * DO NOT hardcode these values in components - always import from here
 */

// Cache durations (in milliseconds)
export const CACHE_DURATION = {
  SEARCH: 15 * 60 * 1000,        // 15 minutes
  GEOLOCATION: 5 * 60 * 1000,    // 5 minutes
  HEALTH_CHECK: 5 * 60 * 1000,   // 5 minutes
  FEATURE_METRICS: 5 * 60 * 1000, // 5 minutes
} as const;

// Rate limiting windows (in milliseconds)
export const RATE_LIMIT_WINDOW = {
  SIGNUP: 5 * 60 * 1000,          // 5 minutes
  LOGIN: 5 * 60 * 1000,           // 5 minutes
  API_GENERAL: 15 * 60 * 1000,    // 15 minutes
  CRITICAL_OP: 5 * 60 * 1000,     // 5 minutes
} as const;

// API timeouts (in milliseconds)
export const API_TIMEOUT = {
  DEFAULT: 30000,                 // 30 seconds
  GEOLOCATION: 10000,            // 10 seconds
  DIRECTIONS: 30000,             // 30 seconds
  HEALTH_CHECK: 3000,            // 3 seconds
} as const;

// Geolocation options
export const GEOLOCATION_OPTIONS: PositionOptions = {
  enableHighAccuracy: true,
  timeout: API_TIMEOUT.GEOLOCATION,
  maximumAge: CACHE_DURATION.GEOLOCATION,
} as const;

// Rate limit attempts
export const RATE_LIMIT_ATTEMPTS = {
  SIGNUP: 3,
  LOGIN: 5,
  API_KEY_CHECK: 10,
  CRITICAL: 3,
  ADMIN_ROLE_UPDATE: 20, // Higher limit for admin operations
} as const;

// Mobile breakpoints (in pixels)
export const BREAKPOINTS = {
  MOBILE: 768,
  TABLET: 1024,
  DESKTOP: 1280,
} as const;

// Performance thresholds (in milliseconds)
export const PERFORMANCE_THRESHOLDS = {
  RENDER_WARN: 100,
  RENDER_ERROR: 500,
  API_WARN: 1000,
  API_ERROR: 3000,
} as const;

// Mobile touch target minimum size (in pixels)
export const TOUCH_TARGET_MIN_SIZE = 44; // Apple HIG recommendation

// Bundle optimization
export const BUNDLE_LIMITS = {
  CHUNK_SIZE_WARNING: 1000, // KB
  MAX_INITIAL_BUNDLE: 500,  // KB
} as const;
